export type RankVisual = {
  id: string
  name: string
  division: string
}

export type RankFamilyVisual = {
  name: string
  range: string
  ranks: RankVisual[]
}

const divisions = [
  { suffix: '1', label: 'I' },
  { suffix: '2', label: 'II' },
  { suffix: '3', label: 'III' },
]

function family(name: string, id: string, range: string): RankFamilyVisual {
  return {
    name,
    range,
    ranks: divisions.map(({ suffix, label }) => ({
      id: `${id}_${suffix}`,
      name: `${name} ${label}`,
      division: label,
    })),
  }
}

export const rankFamilies: RankFamilyVisual[] = [
  family('Bronzo', 'bronze', '0–899 MMR'),
  family('Argento', 'silver', '900–1199 MMR'),
  family('Oro', 'gold', '1200–1499 MMR'),
  family('Platino', 'platinum', '1500–1799 MMR'),
  family('Diamante', 'diamond', '1800–2099 MMR'),
  family('Maestro', 'master', '2100–2399 MMR'),
  family('Gran Maestro', 'grandmaster', '2400–2799 MMR'),
  {
    name: 'TNT Legend',
    range: '2800+ MMR',
    ranks: [
      {
        id: 'tnt_legend',
        name: 'TNT Legend',
        division: '◆',
      },
    ],
  },
]
